import api from "../lib/api";
import { useLang } from "../lib/i18n";

export default function AdSlot({ slot, ads }) {
  const { lang } = useLang();
  const ad = (ads || []).find((a) => a.slot === slot && a.enabled && a.image_url);

  if (!ad) {
    return (
      <div
        data-testid={`ad-slot-${slot}`}
        className="border border-dashed border-gold/60 bg-gold-light/10 py-6 text-center px-4"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          {lang === "hi" ? "विज्ञापन" : "Advertisement"}
        </p>
        <p className="text-sm text-muted-foreground mt-1">
          {lang === "hi"
            ? "यहाँ आपके ब्रांड का विज्ञापन हो सकता है — "
            : "Your brand's ad could be here — "}
          <a href="mailto:Thevainorventures@gmail.com" className="text-deepgreen underline hover:text-gold-accent transition-colors">
            {lang === "hi" ? "संपर्क करें" : "contact us"}
          </a>
        </p>
      </div>
    );
  }

  const click = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
  };

  return (
    <div data-testid={`ad-slot-${slot}`} className="relative border border-ink/15 bg-white overflow-hidden group">
      <span className="absolute top-1.5 right-2 font-mono text-[9px] uppercase tracking-[0.2em] text-muted-foreground z-10 bg-paper/80 px-1.5 py-0.5">
        {lang === "hi" ? "विज्ञापन" : "Ad"}
      </span>
      <a
        href={ad.link || "#"}
        target="_blank"
        rel="noreferrer"
        onClick={click}
        data-testid={`ad-link-${slot}`}
        aria-label={ad.title}
      >
        <img
          src={ad.image_url}
          alt={ad.title}
          className="w-full max-h-32 md:max-h-40 object-cover transition-transform duration-500 group-hover:scale-[1.02]"
        />
      </a>
    </div>
  );
}
